import { render } from "./ShopifyWebstore.vue?vue&type=template&id=12090854&scoped=true"
const script = {}

import "./ShopifyWebstore.vue?vue&type=style&index=0&id=12090854&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12090854"]])

export default __exports__